import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import axiosInstance from '../../../api/axiosInstance';
import { useOnboarding } from '../../../context/OnboardingContext';
import { LuSave } from 'react-icons/lu';
import OnboardingModal from '../onboarding/OnboardingModal';
import OnboardingAlert from '../onboarding/OnboardingAlert';

const ExitConfirmationModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { getCompletedStepsCount, getTotalSteps, state ,resetOnboarding} = useOnboarding();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const completedSteps = getCompletedStepsCount();
  const totalSteps = getTotalSteps();

  const handleExit = async () => {
    setIsLoading(true);
    setError(null);

    try {
      // Prepare wizard data payload from current state
      const wizardDataPayload = {
        wizard_data: {
          engine: state.engine,
          data: state.data
        }
      };

      // Call the API to save draft
      await axiosInstance.post('/wizard/add_wizard_data', wizardDataPayload);

      resetOnboarding(); 

      // Save to localStorage
      // localStorage.setItem('robitest_onboarding_draft_v1', JSON.stringify(state));

      // Clear authentication and navigate to login
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('user');
      onClose();
      navigate('/login');
    } catch (err) {
      console.error('Error saving wizard draft:', err);
      setError(err.response?.data?.message || 'Failed to save progress. Please try again.');
      setIsLoading(false);
    }
  };

  const percent = totalSteps ? Math.round((completedSteps / totalSteps) * 100) : 0;

  return (
    <OnboardingModal
      title="Save and exit setup?"
      description="Your progress will be saved. You can resume anytime by signing back in."
      icon={<LuSave size={20} />}
      tone="primary"
      onClose={onClose}
      footer={
        <>
          <button type="button" className="ob-btn ob-btn--secondary" onClick={handleExit} disabled={isLoading}>
            {isLoading && <span className="ob-spinner" aria-hidden="true" />}
            {isLoading ? 'Exiting...' : 'Save & Exit'}
          </button>
          <button
            type="button"
            className="ob-btn ob-btn--primary"
            onClick={onClose}
            disabled={isLoading}
            data-autofocus
          >
            Continue Setup
          </button>
        </>
      }
    >
      {error && (
        <OnboardingAlert tone="danger" title="Couldn't save your progress">
          <p>{error}</p>
        </OnboardingAlert>
      )}
      <div style={{ marginBottom: 4 }}>
        <div className="ob-progress-meta" style={{ marginTop: 0, marginBottom: 8 }}>
          <span>
            You have completed <strong style={{ color: 'var(--text-primary)' }}>{completedSteps}</strong> of{' '}
            <strong style={{ color: 'var(--text-primary)' }}>{totalSteps}</strong> steps
          </span>
          <span>{percent}%</span>
        </div>
        <div className="ob-progress" aria-hidden="true">
          <div className="ob-progress__fill" style={{ width: `${percent}%` }} />
        </div>
      </div>
    </OnboardingModal>
  );
};

export default ExitConfirmationModal;
